function init_girlown_spring(from_php){
    var main=$(".place.girlown"),special_event=from_php.special_event;
    function init_fightBox(){
        main.find("#mainPVP .hero").qAnim({
            clips:7,
            width:173,
            interval:100,
            loop:1
        });
        
    }
    function init_infoBox(){
        var qbox=main.find("#spingBox");
        main.find("#eventWrap").append(qbox.clone(true));
        qbox.remove();
        
        _timerManager.addTimer(".place.girlown .endSpecialEventTimerJS",special_event.time_end,1);
        main.find("#eventWrap #spingBox").qAnim({
            clips:11,
            width:147,
            interval:100,
            loop:1
        });
        var girlObj=new girlSuitView(1004,{12:381});
        girlObj.makeView(main.find("#girlSP"));
    }
    function initChooseBox(){
        var book_choose=main.find(".book.springreward[g_id='1002']"),
        book_sure=main.find(".book.springreward[g_id='1003']");
        var girl_id=0;
        if(book_choose.length==0){
            return false;
        }
        book_choose.find(".mySelectJS").myPageSelector({width:600,height:342})
        book_sure.on("open",function(){
            book_sure.find(".textJS").html(
                connectVars(special_event.lang_choose,[$.takeGirlNameReal(girl_id)],"#")
            );
        });
        book_choose.find(".girlList .cell[data-girl_id][data-have='0']").click(function(){
            var th=$(this);
            girl_id=intval(th.attr("data-girl_id"));
            book_sure.find("input[name='giveSuitChristmas']").attr("value",th.attr("data-suit_id"));
            book_sure.bookUse("show");
            return false;
        });
        book_choose.find(".girlList").blankCell(5);
        
    //textJS
        
       
    }
    initChooseBox();
    init_fightBox();
    init_infoBox();
    main.find("#tvflash").qAnim({clips:3,width:461,loop:1,interval:350});
}